import { createApi, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import { apiQuery } from "../../utils/api-config";
import type { StoreState } from "../store";
import { QueryReturnValue } from "@reduxjs/toolkit/dist/query/baseQueryTypes";

export type DownloadExcelParams = {
  name?: string;
  pinfl?: string;
  phone?: string;
  fromDate?: string;
  toDate?: string;
  oneczup_role_ids?: string[];
  iiko_role_codes?: string[];
  ispring_role_ids?: string[];
  oneszup_department_ids?: string[];
  iiko_department_codes?: string[] | number[];
  ispring_department_ids?: string[];
  timeZone?: string;
  from_date?: string;
  to_date?: string;
};

export const downloadApi = createApi({
  reducerPath: "downloadApi",
  baseQuery: apiQuery,
  endpoints: (builder) => ({
    downloadExcel: builder.query<Blob, DownloadExcelParams>({
      async queryFn(args, api, _extraOptions, baseQuery) {
        const { timeZone, ...params } = args;
        const queryString = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v) => queryString.append(key, v.toString()));
          } else if (value !== undefined && value !== null) {
            queryString.append(key, value.toString());
          }
        });

        const {
          auth: { token },
        } = api.getState() as StoreState;

        const url = `/employee/download/excel?${queryString.toString()}&apiKey=${token}`;

        const rawResult = await baseQuery({
          url,
          method: "GET",
          headers: timeZone
            ? {
                "X-Time-Zone": timeZone,
              }
            : undefined,
          responseHandler: (response) => response.blob(),
        });

        const result = rawResult as QueryReturnValue<Blob, FetchBaseQueryError>;
        return result;
      },
    }),
  }),
});

export const { useDownloadExcelQuery, useLazyDownloadExcelQuery } = downloadApi;
